
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/auth";

interface VotingHistoryEntry {
  poll_id: string;
  option_id: number;
  voted_at: string;
  poll_title: string;
  poll_description: string;
  country_code: string | null;
  constituency_code: string | null;
  insight_card_title: string | null;
  insight_card_id: string | null;
}

export const useVotingHistory = (userId?: string) => {
  const { user } = useAuth();
  const targetUserId = userId || user?.id;

  return useQuery({
    queryKey: ['voting-history', targetUserId],
    queryFn: async () => {
      if (!targetUserId) return [];
      
      const { data, error } = await supabase.rpc(
        'get_user_voting_history',
        { user_id_param: targetUserId }
      );

      if (error) throw error;
      return data as VotingHistoryEntry[];
    },
    enabled: !!targetUserId
  });
};
